// Navbar.js
import React, { useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';
import kosLogo from '../assets/logo.svg';
import kmaLogo from '../assets/kma_logo_2025.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isKophthMenuOpen, setIsKophthMenuOpen] = useState(false);
  const { isAuthenticated, isAdmin, logout, userData } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsKophthMenuOpen(false);
  };

  const toggleKophthMenu = () => {
    setIsKophthMenuOpen(!isKophthMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      closeMobileMenu();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const isAdminPath = () => {
    return location.pathname.startsWith('/admin');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <div className="logo-box">
            <img src={kosLogo} alt="KOS Logo" className="logo-image" />
          </div>
          <img src={kmaLogo} alt="KMA Logo" className="logo-image" />
        </Link>

        {/* Mobile User Avatar (shown only on mobile) */}
        {isAuthenticated && (
          <Link to="/profile" className="mobile-user-avatar" onClick={closeMobileMenu}>
            <div className="user-avatar">
              {userData?.photoURL ? (
                <img src={userData.photoURL} alt="User avatar" className="avatar-image" />
              ) : (
                <div className="avatar-placeholder">
                  {userData?.fullName?.charAt(0).toUpperCase() || userData?.email?.charAt(0).toUpperCase() || 'U'}
                </div>
              )}
            </div>
          </Link>
        )}

        {/* Mobile Menu Toggle */}
        <button
          className={`mobile-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Menu */}
        <ul className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <li><Link to="/" className={isActive('/')} onClick={closeMobileMenu}>Home</Link></li>
          <li><Link to="/events" className={isActive('/events')} onClick={closeMobileMenu}>Events</Link></li>
          <li><Link to="/rewards" className={isActive('/rewards')} onClick={closeMobileMenu}>Rewards</Link></li>
          <li><Link to="/suggestions" className={isActive('/suggestions')} onClick={closeMobileMenu}>Suggestions</Link></li>
          <li><Link to="/news" className={isActive('/news')} onClick={closeMobileMenu}>News</Link></li>

          {/* KOPHTH Menu */}
          <li className="kophth-menu-item">
            <button
              className="kophth-menu-button"
              onClick={toggleKophthMenu}
              aria-expanded={isKophthMenuOpen}
            >
              Conferences
              <span className={`dropdown-icon ${isKophthMenuOpen ? 'open' : ''}`}>▼</span>
            </button>
            {isKophthMenuOpen && (
              <div className="kophth-dropdown">
                <Link to="/conference-registration" onClick={closeMobileMenu} style={{ fontWeight: 'bold', color: 'var(--color-accent)' }}>
                  Scientific Applications 📝
                </Link>
                <a href="https://www.kophth-2026.com/">
                  KOPHTH 2026
                </a>
                <a href="https://www.kophth-2025.com/">
                  KOPHTH 2025
                </a>
                <a href="#">
                  KOPHTH 2024
                </a>
              </div>
            )}
          </li>

          {isAuthenticated && (
            <>
              <li><Link to="/profile" className={isActive('/profile')} onClick={closeMobileMenu}>Profile</Link></li>
            </>
          )}

          {isAdmin && (
            <li>
              <Link to="/admin" className={isAdminPath() ? 'active' : ''} onClick={closeMobileMenu}>
                Admin Panel
              </Link>
            </li>
          )}

          {isAuthenticated ? (
            <>
              <li className="user-avatar-section">
                <Link to="/profile" className="user-avatar-link" onClick={closeMobileMenu}>
                  <div className="user-avatar">
                    {userData?.photoURL ? (
                      <img src={userData.photoURL} alt="User avatar" className="avatar-image" />
                    ) : (
                      <div className="avatar-placeholder">
                        {userData?.fullName?.charAt(0).toUpperCase() || userData?.email?.charAt(0).toUpperCase() || 'U'}
                      </div>
                    )}
                  </div>
                  <span className="user-name-text">
                    {userData?.fullName || userData?.email?.split('@')[0] || 'User'}
                  </span>
                </Link>
              </li>
              <li className="nav-action">
                <button onClick={handleLogout} className="logout-btn">Logout</button>
              </li>
            </>
          ) : (
            <>
              <li className="nav-action">
                <Link to="/login" className="login-btn" onClick={closeMobileMenu}>Login</Link>
              </li>
              <li className="nav-action">
                <Link to="/register" className="register-btn" onClick={closeMobileMenu}>Register</Link>
              </li>
            </>
          )}
        </ul>
      </div>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && <div className="overlay" onClick={closeMobileMenu}></div>}
    </nav>
  );
};

export default Navbar;
